import React from 'react';

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload || !payload.length) {
    return null;
  }

  // ================== CONDITIONAL LOGIC ==================
  // Change this condition to whatever you actually need
  const showLogicalView = payload.length > 10;

  return (
    <div style={{
      backgroundColor: 'white',
      border: '1px solid #ccc',
      borderRadius: '8px',
      padding: '12px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      fontSize: '14px',
      minWidth: '200px',
      maxWidth: '95%'
    }}>
      <p style={{ 
        margin: '0 0 10px 0', 
        fontWeight: 'bold', 
        borderBottom: '1px solid #eee', 
        paddingBottom: '8px' 
      }}>
        Language: <strong>{label}</strong>
      </p>

      {showLogicalView ? (
        // ===================== LOGICAL VIEW WITH CHIPS =====================
        <div>
          <p style={{ fontWeight: 'bold', margin: '8px 0 6px 0' }}>
            Breakdown by Country:
          </p>

          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {payload
              .filter(entry => entry.value !== undefined && entry.value !== 0)
              .map((entry, index) => (
                <div
                  key={index}
                  style={{
                    backgroundColor: '#f5f5f5',
                    borderLeft: `6px solid ${entry.color || '#888'}`,
                    padding: '6px 10px',
                    borderRadius: '4px',
                    fontSize: '13px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    minWidth: '100px'
                  }}
                >
                  
                  <span>
                    {entry.name} 
                    <strong style={{ marginLeft: '6px' }}>
                      ({entry.value})
                    </strong>
                  </span>
                </div>
              ))}
          </div>

          {/* Optional: Show total */}
          {dataPoint.totalAdapted && (
            <p style={{ marginTop: '12px', fontWeight: 'bold' }}>
              Total Adapted: <strong>{dataPoint.totalAdapted}</strong>
            </p>
          )}
        </div>
      ) : (
        // ===================== NORMAL STACKED VIEW =====================
        <div>
          <p style={{ fontWeight: 'bold', margin: '8px 0 6px 0' }}>
            Breakdown by Country:
          </p>
          
          {payload
            .filter(entry => entry.value !== undefined && entry.value !== 0)
            .map((entry, index) => (
              <p 
                key={index} 
                style={{ 
                  margin: '6px 0', 
                  display: 'flex', 
                  justifyContent: 'space-between' 
                }}
              >
                <span>
                  <span style={{ color: entry.color, marginRight: '6px' }}>■</span>
                  {entry.name}
                </span>
                <strong>{entry.value}</strong>
              </p>
            ))}
        </div>
      )}
    </div>
  );
};

export default CustomTooltip;